import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/teamligue`;
const token = localStorage.getItem("token");

/// GET
// Récupérer tous les membres de la ligue
export const getAllTeamLigue = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des membres de la ligue:", error);
  }
};

// Récupérer un membre par ID
export const getTeamMemberById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du membre :", error);
  }
};

// Récupérer tous les membres d’une commission
export const getTeamByCommission = async (commissionId) => {
  try {
    const response = await axios.get(`${apiUrl}/bycommission/${commissionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des membres par commission :", error);
  }
};

// Compter les membres
export const countTeamMembers = async () => {
  try {
    const response = await axios.get(`${apiUrl}/count`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du comptage des membres de la ligue :", error);
  }
};

/// POST
// Créer un membre
export const createTeamMember = async (teamData) => {
  try {
    await axios.post(`${apiUrl}/create`, teamData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la création du membre :", error);
  }
};

/// PUT
// Mettre à jour un membre
export const updateTeamMember = async (id, teamData) => {
  try {
    await axios.put(`${apiUrl}/update/${id}`, teamData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la mise à jour du membre :", error);
  }
};

/// DELETE
// Supprimer un membre
export const deleteTeamMember = async (id) => {
  try {
    await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Erreur lors de la suppression du membre :", error);
  }
};
